import { useEffect, useState } from 'react'

export const useDebouncedValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const debounceTimeout = setTimeout(() => setDebouncedValue(value), delay)

    return () => {
      clearTimeout(debounceTimeout)
    }
  }, [value, delay])

  return debouncedValue
}
